<template>
    <client-page>
        <div class="client-content-wrap">
            <section class="client-section">
                <v-container>
                    <div class="section-title-wrap">
                        <h2 class="client-title--xxxl">투명경영</h2>
                    </div>
                </v-container>
                <v-img src="/images/about/management/mobile.jpg" alt="" class="d-md-none" />
                <v-img src="/images/about/management/management.jpg" alt="" class="d-none d-md-block" />
            </section>

            <section class="client-section pt-0">
                <v-container>
                    <div class="section-title-wrap">
                        <h2 class="tit tit--md"><span class="primary--text">정직</span>하고 <span class="primary--text">성실</span>하게 일하여 더욱 <span class="primary--text">신뢰</span>받습니다.</h2>
                        <p class="grey-1--text mt-18 mt-md-24">
                            위드캔복지재단은 법과 윤리를 준수하며, 재정과 운영 전반에서 투명성과 책임성을 지키기 위해 최선을 다합니다. <br class="d-none d-xl-block" />
                            우리는 후원자와 수혜자, 그리고 모든 이해관계자에게 신뢰받는 기관이 되기 위해 아래와 같은 원칙을 실천하고 있습니다.
                        </p>
                    </div>

                    <ul class="management-list">
                        <li>
                            <v-row>
                                <v-col cols="12" lg="auto">
                                    <v-sheet width="232">
                                        <div class="client-title--xl primary--text font-weight-bold">첫째,</div>
                                    </v-sheet>
                                </v-col>
                                <v-col>
                                    <div class="tit tit--sm mb-16">투명한 재정 관리</div>
                                    <p class="client-title--sm line-height-16">「사회복지법인 및 사회복지시설 재무회계규칙」, 「기부금품의 모집·사용 및 기부문화 활성화에 관한 법률」 관련 법령에 근거하여 후원금과 사업비 등 모든 수입·지출 내역을 투명하게 운영합니다. 재무현황을 정기적으로 정리해 공개하고, 외부 전문 회계법인을 통한 감사 과정을 거쳐 공정성을 확인받고 있습니다. 이를 통해 후원자와 사회가 안심하고 신뢰할 수 있는 환경을 조성하고자 합니다.</p>
                                    <v-btn to="/board/library" large rounded="pill" color="primary" class="mt-24">
                                        <span class="page-text page-text--lg white--text">발간 자료실 바로가기</span>
                                        <v-icon small class="ml-10">mdi-chevron-right</v-icon>
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </li>
                        <li>
                            <v-row>
                                <v-col cols="12" lg="auto">
                                    <v-sheet width="232">
                                        <div class="client-title--xl primary--text font-weight-bold">둘째,</div>
                                    </v-sheet>
                                </v-col>
                                <v-col>
                                    <div class="tit tit--sm mb-16">공정하고 책임 있는 사업 운영</div>
                                    <p class="client-title--sm line-height-16">국내 복지사업부터 국제개발협력사업에 이르기까지 모든 활동은 명확한 절차와 기준에 따라 진행되며, 각 사업 성과와 지원 현황은 정기 보고서와 홈페이지를 통해 공유합니다. 필요 시 직접 현장을 방문해 사업의 실질적 효과를 확인할 수 있도록 하여, 지원 과정에서도 투명성을 확보하고 있습니다.</p>
                                    <v-btn to="/board/story" large rounded="pill" color="primary" class="mt-24">
                                        <span class="page-text page-text--lg white--text">사업기관 소식 바로가기</span>
                                        <v-icon small class="ml-10">mdi-chevron-right</v-icon>
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </li>
                        <li>
                            <v-row>
                                <v-col cols="12" lg="auto">
                                    <v-sheet width="232">
                                        <div class="client-title--xl primary--text font-weight-bold">셋째,</div>
                                    </v-sheet>
                                </v-col>
                                <v-col>
                                    <div class="tit tit--sm mb-16">윤리·인권 중심 경영</div>
                                    <p class="client-title--sm line-height-16">위드캔복지재단은 사람 중심의 복지를 실천하기 위해 윤리강령을 제정하고, 임직원과 봉사자들이 이를 준수하도록 교육하고 있습니다. 모든 사업 과정에서 차별 없는 지원과 인권 보호를 최우선으로 삼아, 소외계층 누구나 존엄한 삶을 누릴 수 있도록 노력합니다.</p>
                                    <code-of-conduct-dialog>
                                        <template #activator="{ on, attr }">
                                            <v-btn v-on="on" v-bind="attr" large rounded="pill" color="primary" class="mt-24">
                                                <span class="page-text page-text--lg white--text">위드캔복지재단 행동강령 바로가기</span>
                                                <v-icon small class="ml-10">mdi-chevron-right</v-icon>
                                            </v-btn>
                                        </template>
                                    </code-of-conduct-dialog>
                                </v-col>
                            </v-row>
                        </li>
                        <li>
                            <v-row>
                                <v-col cols="12" lg="auto">
                                    <v-sheet width="232">
                                        <div class="client-title--xl primary--text font-weight-bold">넷째,</div>
                                    </v-sheet>
                                </v-col>
                                <v-col>
                                    <div class="tit tit--sm mb-16">공시자료 및 정보 공개</div>
                                    <p class="client-title--sm line-height-16">법령에 따라 정관, 사업보고서, 결산서류 등 주요 정보를 투명경영 페이지에서 공개하고 있습니다. 후원자와 국민 누구나 쉽게 접근할 수 있도록 관련 서류를 주기적으로 갱신하며, 재단 운영의 투명성을 높이고자 계속해서 소통 창구를 확대해 나갑니다.</p>
                                    <v-btn to="/about/board?code=notice" large rounded="pill" color="primary" class="mt-24">
                                        <span class="page-text page-text--lg white--text">공시자료 바로가기</span>
                                        <v-icon small class="ml-10">mdi-chevron-right</v-icon>
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </li>
                    </ul>
                </v-container>
            </section>

            <section class="client-section" id="report">
                <v-container>
                    <div class="section-title-wrap">
                        <p class="client-title--sm font-weight-medium primary--text line-height-15">Financial Reporting</p>
                        <h2 class="section-title">재무보고</h2>
                    </div>
                    <div class="section-title-wrap">
                        <p class="client-title--sm text-center">2024년 1월 1일부터 12월 31일까지를 기준으로 작성된 위드캔복지재단의 수입 및 지출 내역을 공개합니다.</p>
                    </div>

                    <v-simple-table class="v-data-table--no-hover">
                        <tbody>
                            <tr>
                                <th rowspan="7">수입내역</th>
                                <th>구분</th>
                                <th>결산</th>
                                <th>세부내용</th>
                            </tr>
                            <tr>
                                <td>재산수입</td>
                                <td>21,600,000</td>
                                <td>임대료수입</td>
                            </tr>
                            <tr>
                                <td>비지정후원금</td>
                                <td>163,468,700</td>
                                <td>CMS, 일시후원, 해피빈</td>
                            </tr>
                            <tr>
                                <td>지정후원금</td>
                                <td>190,718,513</td>
                                <td>정기 및 일시후원</td>
                            </tr>
                            <tr>
                                <td>이월금</td>
                                <td>248,181,769</td>
                                <td>통장 이월금</td>
                            </tr>
                            <tr>
                                <td>잡수입</td>
                                <td>214,452,180</td>
                                <td>장애인고용장려금, 예금이자</td>
                            </tr>
                            <tr>
                                <td>
                                    <strong>총계</strong>
                                </td>
                                <td>
                                    <strong>838,421,162</strong>
                                </td>
                                <td></td>
                            </tr>
                        </tbody>
                    </v-simple-table>

                    <v-simple-table class="v-data-table--no-hover">
                        <tbody>
                            <tr>
                                <th rowspan="11">지출내역</th>
                                <th colspan="2">구분</th>
                                <th>결산</th>
                                <th>세부내용</th>
                            </tr>
                            <tr>
                                <th rowspan="4">국내사업</th>
                                <td>복지사업비</td>
                                <td>16,208,730</td>
                                <td>산하기관 연계사업</td>
                            </tr>
                            <tr>
                                <td>교육사업비</td>
                                <td>6,120,000</td>
                                <td>모금마케팅TF역량강화 교육 외</td>
                            </tr>
                            <tr>
                                <td>홍보사업 및 기타 사업비</td>
                                <td>14,369,500</td>
                                <td>모금캠페인 광고비, 영상제작비</td>
                            </tr>
                            <tr>
                                <td>종사자 교육 훈련비</td>
                                <td>11,289,860</td>
                                <td>종사자 워크숍 및 교육훈련비</td>
                            </tr>
                            <tr>
                                <th>해외사업</th>
                                <td>해외사업지원비</td>
                                <td>1,980,000</td>
                                <td>미얀마 소방지원사업</td>
                            </tr>
                            <tr>
                                <td colspan="2">
                                    <span>계</span>
                                </td>
                                <td>
                                    <span>49,968,090</span>
                                </td>
                                <td></td>
                            </tr>
                            <tr>
                                <td colspan="2">일반관리비</td>
                                <td>190,969,321</td>
                                <td>사무국 운영관리비</td>
                            </tr>
                            <tr>
                                <td colspan="2">시설전출금</td>
                                <td>147,100,000</td>
                                <td>법인전입금</td>
                            </tr>
                            <tr>
                                <td colspan="2">차년도 복지사업비(이월금)</td>
                                <td>450,383,751</td>
                                <td>차년도 사업수행준비금</td>
                            </tr>
                            <tr>
                                <td colspan="2">
                                    <strong>총계</strong>
                                </td>
                                <td>
                                    <strong>838,421,162</strong>
                                </td>
                                <td></td>
                            </tr>
                        </tbody>
                    </v-simple-table>

                    <div class="text-center">
                        <v-btn to="/board/library" large rounded="pill" color="primary" width="160" class="mt-24">
                            <span class="page-text page-text--lg white--text">자세히 보기</span>
                            <v-icon small class="ml-10">mdi-chevron-right</v-icon>
                        </v-btn>
                    </div>
                </v-container>
            </section>

            <section class="client-section pt-0">
                <v-container>
                    <v-row class="row--sm">
                        <v-col v-for="(board, index) in boards" :key="index" cols="12" lg="6">
                            <v-btn block color="primary" outlined x-large rounded="pill" @click="download(`${board?.files[0]?.url}`, `${board?.subject}`)">
                                <v-row justify="space-between">
                                    <v-col cols="auto">
                                        <span class="font-weight-bold">
                                            {{ board.subject }}
                                        </span>
                                    </v-col>
                                    <v-col cols="auto">
                                        <v-icon>mdi-text-box-search-outline</v-icon>
                                    </v-col>
                                </v-row>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </section>
        </div>
    </client-page>
</template>

<script>
import api from "@/api";
import download from "downloadjs";
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import CodeOfConductDialog from "@/components/client/about/code-of-conduct-dialog.vue";

export default {
    components: {
        ClientPage,
        CodeOfConductDialog,
    },
    data() {
        return {
            boards: [],
        };
    },
    methods: {
        async init() {
            var { boards } = await api.v1.boards.gets({ params: { code: "finance" } });
            this.boards = boards;
        },
        download(path, rename) {
            api.getResource(path).then((file) => download(file, rename));
        },
    },
    mounted() {
        this.init();
    },
};
</script>

<style lang="scss" scoped>
.management-list {
    border-top: 1px solid;
    border-color: #ddd;
    > li {
        border-bottom: 1px solid;
        border-color: inherit;
        padding: 40px 0;
    }
}
.v-data-table {
    border-top: 1px solid #111;
    border-bottom: 1px solid #111;
    border-radius: 0;
    th,
    td {
        border-right: 1px solid #ddd;
        text-align: center !important;
        font-size: 14px !important;
        word-break: keep-all;
    }
    th {
        background-color: #f5f5f5;
    }
    td {
        > span,
        > strong {
            color: var(--v-primary-base);
        }
    }
}

.v-data-table + .v-data-table {
    margin-top: 40px;
}
@media (min-width: 768px) {
    .management-list {
        > li {
            padding: 60px 0;
        }
    }
    .v-data-table {
        th,
        td {
            font-size: 18px !important;
        }
    }
    .v-data-table + .v-data-table {
        margin-top: 80px;
    }
}
</style>